import {ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {BusinessFieldRef} from '../../model/BusinessFieldRef';
import {BusinessFieldViewType} from '../../model/BusinessFieldViewType';
import {BoInstanceSelectorRecord} from '../../model/BoInstanceSelectorRecord';
import {FormFieldInstance} from '../../model/FormFieldInstance';
import {BusinessObjectDetails} from '../../model/BusinessObjectDetails';
import {DYNAMIC_FORMS_SERVICE, DynamicFormsService} from '../DynamicFormsService';
import {BoAutocompleteOption} from '../../model/BoAutocompleteOption';
import {BoInstance} from '../../model/BoInstance';
import {SubSink} from '../../lib/SubSink';
import {DynamicFormControl} from '../DynamicFormControl';
import {debounceTime, distinctUntilChanged, filter, tap} from 'rxjs/operators';
import {DEBOUNCE_TIME} from '../Util';
import {BoAutocompleteOptionsRequest} from '../../model/BoAutocompleteOptionsRequest';
import {BoInstanceDialogType} from '../../model/BoInstanceDialogType';

@Component({
  selector: 'app-bo-fields',
  templateUrl: './bo-fields.component.html',
  styleUrls: ['./bo-fields.component.scss']
})
export class BoFieldsComponent implements OnInit, OnDestroy {

  private _businessFields: BusinessFieldRef[];
  get businessFields(): BusinessFieldRef[] {
    return this._businessFields;
  }

  @Input() set businessFields(value: BusinessFieldRef[]) {
    this.initFields();
    this._businessFields = value;
  }

  @Input() type: BusinessFieldViewType;
  @Input() businessObjectId: string;
  @Input() chosenIds: string[];
  @Input() ownerBoId: string;
  @Input() ownerBoInstanceId: string;
  @Input() ownerFieldId: string;
  @Output() boInstanceAdded = new EventEmitter<BoInstanceSelectorRecord>();
  @Output() boInstanceDeleted = new EventEmitter<BoInstanceSelectorRecord>();
  @Output() allBoInstanceDeleted = new EventEmitter<BoInstanceSelectorRecord>();
  fields: FormFieldInstance[];
  formControl: DynamicFormControl;
  businessObjectDetails: BusinessObjectDetails;
  boInstance: BoInstance;

  private readonly subs = new SubSink();

  constructor(
    @Inject(DYNAMIC_FORMS_SERVICE)
    private readonly service: DynamicFormsService,
    private readonly cdr: ChangeDetectorRef,
  ) { }

  async ngOnInit() {
    await this.loadBoDetails();
    this.initFields();
    if (this.chosenIds && this.chosenIds.length > 0) {
      await this.loadBoInstance();
      this.initValues();
    }
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private async loadBoDetails() {
    this.businessObjectDetails = await this.service.loadBoDetails(this.businessObjectId, BoInstanceDialogType.VIEW, null);
  }

  async completeForm(option: BoAutocompleteOption) {
    const boInstance: BoInstance = await this.service.loadBoInstance(this.businessObjectId, option.boInstanceId).toPromise();

    if (!boInstance) { return; }

    for (const field of this.businessFields) {
      const value = boInstance.fields.find(x => x.fieldId === field.fieldId)?.value;
      this.formControl.setValue(field.fieldId, value);
    }

    this.businessObjectDetails.fields.forEach(x => x.isReadonly = true);
    this.allBoInstanceDeleted.emit();
    this.boInstanceAdded.emit({boInstanceId: boInstance.boInstanceId} as BoInstanceSelectorRecord);
  }

  private initFields() {
    if (!this.businessObjectDetails) { return; }
    const allFields = this.businessObjectDetails.fields;
    this.fields = allFields.filter(all => {
      const ref = this.businessFields.find(need => all.fieldId === need.fieldId && need.toShow);
      return !!ref;
    });

    this.formControl = new DynamicFormControl({
      fields: this.fields,
      needAutocomplete: true,
      ownerData: {
        ownerBoId: this.businessObjectId,
        ownerBoInstanceId: undefined
      },
    });

    for (const field of this.fields) {

      this.subs.sink = this.formControl.valueChanged.pipe(
        filter(({fieldId}) => fieldId === field.fieldId),
        debounceTime(DEBOUNCE_TIME),
        distinctUntilChanged(),
        tap(({value}) => this.fieldValueChanged(field, value)),
      ).subscribe(({value}) => this.fillAutocompleteOptions(field, value));

    }

    this.formControl.autocompleteClicked.subscribe(
      option => this.completeForm(option)
    );

    this.cdr.detectChanges();
  }

  private async loadBoInstance() {
    this.boInstance = await this.service.loadBoInstance(this.businessObjectId, this.chosenIds[0]).toPromise();
  }

  private initValues() {
    for (const field of this.fields) {
      const boFieldWithValue = this.boInstance.fields.find(x => x.fieldId === field.fieldId);
      this.formControl.setValue(field.fieldId, boFieldWithValue?.value);
    }
  }

  private async fieldValueChanged(field: FormFieldInstance, value: string) {
    // todo golib;

    // this.boToSave = {} as BoInstanceToSave;
    // this.boToSave.businessId = this.chosenIds ? this.chosenIds[0] : undefined;
    // this.boToSave.businessObjectId = this.businessObjectDetails.id;
    // this.boToSave.fields = [];
    //
    // const find = this.boToSave.fields.find(fieldIn => fieldIn.fieldId === field.fieldId);
    //
    // if (find) {
    //   find.value = value;
    // } else {
    //   this.boToSave.fields.push({fieldId: field.fieldId, value, displayValue: value});
    // }

    // const rec: TableInstanceRecord = await this.service.saveBusinessObjectInstance(this.boToSave);
    // this.chosenIds = [rec.instanceId];
    // this.allBoInstanceDeleted.emit();
    // this.boInstanceAdded.emit({boInstanceId: rec.instanceId} as BoInstanceSelectorRecord);
  }

  private async fillAutocompleteOptions(field: FormFieldInstance, value: string) {
    if (!value) { return; }
    const req: BoAutocompleteOptionsRequest = {
      businessObjectId: this.businessObjectId,
      fieldId: field.fieldId,
      startWith: value,
      ownerBoId: this.ownerBoId,
      ownerBoInstanceId: this.ownerBoInstanceId,
      ownerFieldId: this.ownerFieldId,
    };

    const options = await this.service.loadBoAutocompleteOptions(req);
    // this.dynamicForm.getFieldById(field.fieldId).showAutocomplete(options);
  }
}
